import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
// Components
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { PageNotfoundComponent } from './pages/page-not-found/page-not-found.component';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { CacheBustingInterceptor } from './cache-busting.interceptor';
// export function appInitializerFactory(translate: TranslateService, injector: Injector,) {
//   return () => new Promise<any>((resolve: any) => {
//     const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
//     locationInitialized.then(() => {
//       let lang = localStorage.getItem('ngx-webstorage|locallanguage');
//       let langToSet;
      
//       if (lang == null) {
//         langToSet = 'my';
//       } else {
//         langToSet = lang.toString().replace(/['"]+/g, '')
//       }
//       translate.setDefaultLang(langToSet);
//       translate.use(langToSet).subscribe(() => {
//         //console.info(`Successfully initialized '${langToSet}' language.'`);
//       }, err => {
//        // console.error(`Problem with '${langToSet}' language initialization.'`);
//       }, () => {
//         resolve(null);
//       });
//     });
//   });
// }stotp-cc883.firebaseapp.com
// const firebaseConfig = {
//   apiKey: "AIzaSyDoLo6w8Mg0MjNrAfwvhpfu7_lgbZ7mYnc",
//   authDomain: "app.gbost11.com",
//   projectId: "stotp-cc883",
//   storageBucket: "stotp-cc883.appspot.com",
//   messagingSenderId: "414478653913",
//   appId: "1:414478653913:web:76d06b461f27f02cc361c8",
//   measurementId: "G-5RCHXLNXHS"
// };

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    PageNotfoundComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    // TranslateModule.forRoot({
    //   loader: {
    //       provide: TranslateLoader,
    //       useFactory: HttpLoaderFactory,
    //       deps: [HttpClient]
    //   },
    // }),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http:HttpClient) => { return new TranslateHttpLoader(http, '/assets/i18n/', '.json');},
          deps: [HttpClient]         
      }
    }),
    AppRoutingModule,
    SharedModule,

  ],
  providers: [
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: appInitializerFactory,
    //   deps: [TranslateService, Injector],
    //   multi: true
    // }
    InAppBrowser,
   { provide: HTTP_INTERCEPTORS, useClass: CacheBustingInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }